import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import createRelationService from '../../services/relations/createRelationService';
import RelationForm from './RelationForm';

const EMPTY_RELATION = {};

const NewRelation = ({
  open,
  dispatchCreateRelationPost,
  createRelationFetch,
  communityId,
  rootUrl,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    body => dispatchCreateRelationPost({ ...body, communityId }, () => navigate(rootUrl), t),
    [dispatchCreateRelationPost, communityId, rootUrl, t, navigate]
  );

  if (!open) return null;

  return (
    <RelationForm
      header={t('newRelation')}
      onSubmit={handleSubmit}
      submitProcessing={createRelationFetch.pending}
      returnRoute={rootUrl}
      cancelRoute={rootUrl}
      data={EMPTY_RELATION}
      communityId={communityId}
    />
  );
};

NewRelation.propTypes = {
  rootUrl: PropTypes.string.isRequired,
  communityId: PropTypes.string.isRequired,
  dispatchCreateRelationPost: PropTypes.func.isRequired,
  createRelationFetch: PropTypes.object.isRequired,
  open: PropTypes.bool,
};

NewRelation.defaultProps = { open: false };

export default createRelationService(NewRelation);
